import { render, staticRenderFns } from "./NewsletterForm.vue?vue&type=template&id=16a0d5ed&scoped=true"
import script from "./NewsletterForm.vue?vue&type=script&lang=js"
export * from "./NewsletterForm.vue?vue&type=script&lang=js"
import style0 from "./NewsletterForm.vue?vue&type=style&index=0&id=16a0d5ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a0d5ed",
  null
  
)

export default component.exports